import { APP_STORE_URL, GOOGLE_PLAY_URL } from "../../constants/stores";
import appStoreIcon from "../../assets/icons/app-store-128x128.png";
import googlePlayIcon from "../../assets/icons/google-play-128x128.png";

const external = { target: "_blank", rel: "noopener noreferrer" };

const STORES = [
  { href: APP_STORE_URL, icon: appStoreIcon, small: "App Store'dan", name: "İndir · iOS" },
  { href: GOOGLE_PLAY_URL, icon: googlePlayIcon, small: "Google Play'den", name: "İndir · Android" },
];

/** App Store ve Google Play düğmeleri; koyu, yuvarlak, rozete benzer. */
export default function StoreButtons({ className = "" }) {
  return (
    <div className={`flex flex-col sm:flex-row gap-3 ${className}`}>
      {STORES.map((store) => (
        <a
          key={store.href}
          href={store.href}
          {...external}
          className="group inline-flex items-center gap-3 rounded-2xl bg-terakkiInk px-5 py-3 text-white shadow-lg shadow-terakkiInk/20 transition-all duration-200 hover:-translate-y-0.5 hover:bg-terakkiPrimaryDark"
        >
          <img src={store.icon} alt="" aria-hidden className="h-7 w-7 rounded-md bg-white p-0.5" />
          <span className="flex flex-col leading-tight text-left">
            <span className="text-[11px] text-white/70">{store.small}</span>
            <span className="text-base font-SemiBold">{store.name}</span>
          </span>
        </a>
      ))}
    </div>
  );
}
